/* unplugin-vue-components disabled */import { render } from "./CountryCode.vue?vue&type=template&id=661765f6&scoped=true"
import script from "./CountryCode.vue?vue&type=script&lang=js"
export * from "./CountryCode.vue?vue&type=script&lang=js"

import "./CountryCode.vue?vue&type=style&index=0&id=661765f6&lang=scss&scoped=true"
import "./CountryCode.vue?vue&type=style&index=1&id=661765f6&lang=scss"

import exportComponent from "/data/repos/231_20260324095708/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661765f6"]])

export default __exports__